import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { apiNames } from 'shared/consts/api-names';
import {
    CodeModel,
    DeviceCostModel,
    DeviceModel,
    DeviceQueryModel,
    DeviceTrainingModel,
    ImagePrediction,
    IterationModel,
    PagedResultModel
} from 'shared/definition';
import { GenericApiFactory } from 'shared/factories';
import { CodeManagementApiService, GenericApiService, GetOptions } from 'shared/services/index';

import { DeviceDepreciationModel } from '../definition/device/device';
import { toHttpParams } from '../utils/to-http-params';

@Injectable({
    providedIn: 'root'
})
export class DeviceService extends GenericApiService<DeviceModel, any> {
    deviceState$ = this.codeService.getCodeList(apiNames.deviceState);
    deviceCategories$ = this.genericApiFactory.create<CodeModel, any>(apiNames.deviceCategory).getList();
    deviceTypes$ = this.genericApiFactory.create<CodeModel, any>(apiNames.deviceType).getList();

    constructor(
        injector: Injector,
        private genericApiFactory: GenericApiFactory,
        private codeService: CodeManagementApiService
    ) {
        super(injector, 'device');
    }

    deviceTraining(model: DeviceTrainingModel) {
        return this.httpClient.post<DeviceTrainingModel>(this.apiUrl + `/devicetraining/${model.deviceId}`, model);
    }

    devicePredict(url: string) {
        const params = { fileName: url };
        return this.httpClient.post<ImagePrediction>(this.apiUrl + `/devicepredict`, params);
    }

    getIteration() {
        return this.httpClient.get<IterationModel>(this.apiUrl + `/iteration`);
    }


    getDeviceCurrentValue = (id: string) => {
        return this.httpClient.get<number>(this.apiUrl + `/${id}/CurrentValue`);
    };

    getDepreciationsByDeviceId = (id: string) => {
        return this.httpClient.get<DeviceDepreciationModel[]>(this.apiUrl + `/${id}/Depreciations`);
    };

    getDeviceByOption = (plantId: string, deviceTypeId: string) => {
        return this.httpClient.get<DeviceModel[]>(this.apiUrl + `/${plantId}/${deviceTypeId}`);
    };

    getDeviceMaintainCostRecord = (id: string) => {
        return this.httpClient.get<DeviceCostModel[]>(this.apiUrl + `/${id}/MaintainCostRecords`);
    };

    getDeviceRepairCostRecord = (id: string) => {
        return this.httpClient.get<DeviceCostModel[]>(this.apiUrl + `/${id}/RepairCostRecords`);
    };
    getDeviceMaintainCostSum = (id: string) => {
        return this.httpClient.get<DeviceCostModel[]>(this.apiUrl + `/${id}/MaintainCostSum`);
    };

    getDeviceRepairCostSum = (id: string) => {
        return this.httpClient.get<DeviceCostModel[]>(this.apiUrl + `/${id}/RepairCostSum`);
    };

    getCorollaryDeviceList(queryModel: DeviceQueryModel): Observable<PagedResultModel<DeviceModel>> {
        return this.httpClient.post<PagedResultModel<DeviceModel>>(`${this.apiUrl}/CorollaryDeviceList`, queryModel);
    }

    getDeviceListByProject(nodeType: string, projectId: string) {
        return this.httpClient.get<DeviceModel[]>(`${this.apiUrl}/${nodeType}/${projectId}`);
    }

    getDeviceListByCustomer(customerId: string) {
        return this.httpClient.get<DeviceModel[]>(`${this.apiUrl}/getDeviceListByCustomer/${customerId}`);
    }

    getDeviceSelectItems() {
        return this.httpClient.get<Array<any>>(`${this.apiUrl}/getDeviceSelectItems`);
    }
    downloadQrCodeZipPackage(queryModel: DeviceQueryModel = undefined, options: GetOptions = undefined) {
        options = {
            ...{
                showSpinning: true
            },
            ...options
        };
        const params = toHttpParams(queryModel);
        let action$ = this.httpClient.get<PagedResultModel<DeviceQueryModel>>(`${this.apiUrl}/qrcode`, { params });
        if (options.showSpinning) {
            action$ = this.spinningService.startWith(action$);
        }
        return action$;
    }

    getDeviceListByFullName(fullNames: string[]) {
        return this.httpClient.post<DeviceModel[]>(`${this.apiUrl}/GetDeviceListByFullName`, fullNames);
    }

    getDeviceList() {
        return this.httpClient.get<DeviceModel[]>(`${this.apiUrl}`);
    }

    getAllDeviceSn(){
        return this.httpClient.get<any>(`${this.apiUrl}/GetAllDeviceSn`);
    }

}


